export class SecretKey {
    secretKey: string;
    code: string;
    isValid: boolean;
}